import { SVGProps } from 'react';

export const CircleCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8.78594 14.924L4.29297 10.4311L6.00677 8.71726L8.78594 11.4964L13.9892 6.29321L15.703 8.00702L8.78594 14.924ZM10 0C4.486 0 0 4.486 0 10C0 15.515 4.486 20 10 20C15.514 20 20 15.515 20 10C20 4.486 15.514 0 10 0Z"
      fill="currentColor"
    />
  </svg>
);
